import React from "react";
import Confirmationpopup from "@components/ConfirmationPopup";
import {
  RevokeDataAcquisitionInstance,
  GetSFMDisplay,
} from "@helpers/helpers";
import SfmModalStore from "@stores/SfmModalStore";

/**
 * RevocationConfirmation Component
 * Handles the confirmation popup for revoking data acquisition instances
 * Manages revocation statistics and confirmation UI
 */
const RevocationConfirmation = ({
  isOpen,
  revocableStats,
  store,
  onClose,
}) => {
  if (!isOpen || !Object.keys(revocableStats).length) {
    return null;
  }

  const handleRevoke = () => {
    RevokeDataAcquisitionInstance(
      revocableStats.DataAcquisitionInstanceId,
      revocableStats.TotalPromotedRecords,
      revocableStats.TotalRevocableRecords,
      (data) => {
        const sfmData = GetSFMDisplay(data.SFM);
        SfmModalStore.open(sfmData, () => {
          window.location.href = "/data-acquisitions-instances";
        });
      },
      store
    );
  };

  return (
    <Confirmationpopup
      singleAction={{
        actionFN: handleRevoke,
        confirmation: true,
        confirmationMessage: revocableStats.message,
        severity: "high",
      }}
      setOpenConfirmationAction={onClose}
    />
  );
};

export default RevocationConfirmation;
